<template>
  <div class="about-video section-gap mt-5 mr-5 ml-5">
    <!-- <div class="container">
      <div class="section-title-wrapper text-center">
        <h2>Let's Work Together</h2>
        <div class="row">
          <div class="col-sm-12 col-md-6 mx-auto text-center">
            <p
              class="mb-0 lead"
            >We design and develop software for funded startups and established companies. Here are just some examples.</p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-sm-12 col-md-12 col-lg-12">
      <div class="border-0 shadow-md text-white border-rad p-5">
        <div class="row" v-if="Video">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <youtube
              :video-id="getId"
              ref="youtube"
              :autoplay="1"
              :fitParent="false"
            ></youtube>
          </div>
          <span
            class="_addtoFav py-2 px-3 position-absolute"
            @click.stop="UpdateStatus(Video)"
          >
            <i class="fa fa-heart text-white fa-3x" v-if="Video && Video.IsFavorite"></i>
            <i class="far fa-heart text-white fa-3x" v-else></i>
          </span>

          <div class="col-sm-12 col-md-12 col-lg-6">
            <!-- Book Name -->

            <h1
              class="p-2 font-weight-bold font-3x"
              style="
                border-radius: 8px;
                position: relative;
                width: 100%;
                background-color: #f78500;
                color: #f2f2f2;
              "
              v-if="Video"
            >
              {{ Video.Name }}
            </h1>

            <!-- <h4 class="mb-2">{{ ListOfData.Name }}</h4> -->
            <h3 class="font-weight-bold">
              {{ $t("AuthorNameVideo") }} : {{ Video.AuthorName }}
            </h3>
            <h3 class="font-weight-bold">
              {{ $t("Category") }} : {{ Video.LibraryCategoryName }}
            </h3>
            <h3 class="font-weight-bold">
              {{ $t("publishedDate") }} :
              {{ Video.PublishDate | formatDate("yyyy/MM/dd") }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Video: {
      type: Object,
    },
  },
  data() {
    return {
      playerVars: {
        autoplay: 1,
      },
    };
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
    getId() {
      debugger;
      if (this.Video != null && this.Video.URL != null && this.Video.URL != undefined) {
        return this.$youtube.getIdFromUrl(this.Video.URL);
      }
      return null;
    },
  },
  methods: {
    UpdateStatus(item) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.libraryID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            if (this.Video != null && this.Video.IsFavorite != null && this.Video.IsFavorite != undefined) {
              this.Video.IsFavorite = !this.Video.IsFavorite;
            } else {
              this.Video.IsFavorite = false;
            }
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
    async playVideo() {
      await this.player.playVideo();
      // Do something after the playVideo command
    },
  },
};
</script>
